export default __webpack_public_path__ + "static/media/gallery-wip-cover_03.edfcdd02.jpg";